// @flow
import * as Castle from '@castleio/castle-js';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function castleOutgoingPaymentMapper (): Promise<$Shape<OutgoingPayment>> {
  const castle = Castle.configure({pk: ENV_CONSTANTS.CASTLE_PUBLIC_KEY});
  const requestToken = await castle.createRequestToken();

  return {castle_request_token: requestToken};
}
